import { useAtomValue } from 'jotai';

import { useTheme } from '../../hooks/useTheme';
import { useVideoPlatform } from '../../hooks/useVideoPlatform';
import { AudioControlWrapper } from '../../session/controls/AudioControlWrapper';
import { VideoControlWrapper } from '../../session/controls/VideoControlWrapper';
import { Theme } from '../../state/theme';
import { LocalMediaStatus, VideoPlatform, localAudioContextAtom, localVideoContextAtom } from '../../video-sdk';
import { permissionDeniedAtom } from '../../video-sdk/twilio';
import {
  AudioVideoTroubleshootActionItem,
  AudioVideoTroubleshootActionItemProps,
} from './AudioVideoTroubleshootActionItem';
import { BlockedPermissionsActionItemWrapper } from './BlockedPermissionsActionItemWrapper';

export function AudioVideoTroubleshootActionItemWrapper(
  props: Pick<AudioVideoTroubleshootActionItemProps, 'onOpenSettings'>,
) {
  const { theme } = useTheme();
  const blockedPermissions = useAtomValue(permissionDeniedAtom);
  const { videoIsBlocked, microphoneIsBlocked } = blockedPermissions;
  const videoPlatformIsZoom = useVideoPlatform() === VideoPlatform.Zoom;

  const { delegator: localVideoDelegator, status: localVideoStatus } = useAtomValue(localVideoContextAtom);
  const { delegator: localAudioDelegator, status: localAudioStatus } = useAtomValue(localAudioContextAtom);
  const isVideoEnabled = localVideoDelegator && localVideoStatus === LocalMediaStatus.READY;
  const isAudioEnabled = localAudioDelegator && localAudioStatus === LocalMediaStatus.READY;

  return (
    <AudioVideoTroubleshootActionItem
      audioControlComponent={AudioControlWrapper}
      videoControlComponent={VideoControlWrapper}
      blockedPermissionsActionItemComponent={BlockedPermissionsActionItemWrapper}
      {...props}
      isDarkTheme={theme === Theme.DARK}
      permissionIsBlocked={videoIsBlocked || microphoneIsBlocked}
      isVideoEnabled={isVideoEnabled}
      isAudioEnabled={isAudioEnabled}
      shouldShowVideoQualitySettings={!videoPlatformIsZoom}
    />
  );
}
